export const CURRENT_VERSION = (window as any).APP_VERSION;
const VERSION_KEY = 'APP_VERSION';

export const handleAppVersion = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);

  if (!storedVersion) {
    console.log(`First-time load. Setting app version: ${CURRENT_VERSION}`);
    localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
  } else if (storedVersion !== CURRENT_VERSION) {
    console.log(`App version updated: ${storedVersion} -> ${CURRENT_VERSION}`);
    const preservedKeys = ['user_preferences']; // Replace with keys to keep
    const tempStorage: Record<string, string | null> = {};

    preservedKeys.forEach((key) => {
      tempStorage[key] = localStorage.getItem(key);
    });

    localStorage.clear();

    preservedKeys.forEach((key) => {
      if (tempStorage[key]) {
        localStorage.setItem(key, tempStorage[key]!);
      }
    });

    localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
  }
};
